// import { apiURLVeloe, apiAuthorization } from '../../../config.json'

import config from '../../config.json'
import { apiURL, publicSite } from '../../config'
const {
  apiURLVeloe,
  apiAuthorization,
  apiAuthorizationC6,
  brasPagURL,
  buildNumber,
  authScope
} = config

export const API_URL = `${apiURL}`
export const PUBLIC_SITE_URL = `${publicSite}`
export const BUILD_NUMBER = `build.${buildNumber}`
export const BRASPAG_URL = `${brasPagURL}`
export const LOGOUT = '/auth/logout'
export const API_BRASPAG_CARD_URL = `${brasPagURL}/card`
export const API_BRASPAG_TOKEN_URL = `${apiURLVeloe}/ms-proxy/gateway/accesstoken`
export const AUTH_URL = `${apiURLVeloe}/auth/v1/authentication/token`
export const REVOKE_TOKEN = `${apiURLVeloe}/auth/v1/revoke-token`
export const AUTH_SCOPE = authScope
export const API_AUTHORIZATION = apiAuthorization
export const API_AUTHORIZATION_C6 = apiAuthorizationC6
export const GRAPHQL_URL = `${apiURLVeloe}/api/graphql`
export const CHANGE_PASSWORD = `${apiURLVeloe}/auth/v1/alterar-senha`
export const GRAPHQL_MAX_RETY = 5
export const AJAX_MAX_RETRY = 5



// WEBPACK FOOTER //
// ./src/alelo-logic/services/common/constants.js